// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader/dist/cjs.js?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-cfc22cf6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Article/ArticlesReport.vue
// module id = 468
// module chunks = 0